import { useState } from "react";
import { ChevronDown, MapPin, ShieldCheck } from "lucide-react";
import { ROBOTIC_SURGERY_IMAGE } from "./data";
import { Reveal } from "./Reveal";

const INITIAL_FAQ_COUNT = 6;
const FAQ_PAGE_SIZE = 10;

export function FaqSection({ faqs }) {
  const [openFaq, setOpenFaq] = useState(0);
  const [visibleCount, setVisibleCount] = useState(INITIAL_FAQ_COUNT);
  const allShown = visibleCount >= faqs.length;
  const visibleFaqs = faqs.slice(0, visibleCount);
  return (
    <section className="section resources-section" id="faq">
      <div className="container resources-grid">
        <div>
          <Reveal>
            <div className="section-label"><span className="chapter-no">06</span>Good to know</div>
            <h2>Answers for your next step.</h2>
            <p className="lead">A little clarity can make seeking care feel easier.</p>
            <div className="resource-note"><ShieldCheck size={20} /><span><b>Private, respectful consultations</b><small>Your concerns are listened to with care.</small></span></div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="hospital-image resources-image">
              <img data-testid="hospital-image" src={ROBOTIC_SURGERY_IMAGE} alt="Dr. Sreeniketh Reddy performing robotic urology surgery at Medicover Hitec City, Hyderabad" />
              <div className="map-pin"><MapPin size={18} fill="currentColor" /> Robotic &amp; minimally invasive surgery</div>
            </div>
          </Reveal>
        </div>
        <div>
          <div className="faq-list">
            {visibleFaqs.map(([question, answer], index) => (
              <Reveal key={question} delay={Math.min(index, 8) * 0.06}>
                <div className={`faq-item ${openFaq === index ? "active" : ""}`}>
                  <button data-testid={`faq-question-${index}`} onClick={() => setOpenFaq(openFaq === index ? -1 : index)}><span>{question}</span><ChevronDown size={18} /></button>
                  {openFaq === index && <p data-testid={`faq-answer-${index}`}>{answer}</p>}
                </div>
              </Reveal>
            ))}
          </div>
          {faqs.length > INITIAL_FAQ_COUNT && (
            <button className={`faq-more-toggle ${allShown ? "open" : ""}`} data-testid="faq-show-all-toggle" onClick={() => setVisibleCount(allShown ? INITIAL_FAQ_COUNT : visibleCount + FAQ_PAGE_SIZE)}>
              <span>{allShown ? "Show fewer questions" : "Show 10 more questions"}</span><ChevronDown size={16} />
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
